// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { jettingAppUnitsToggleStyles } from "@stoneage/App/Components/JettingAppComponents/JettingAppUnitsToggle";
import { color } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

jettingAppUnitsToggleStyles.wrapper = {
    css: css`
        display: flex;
        align-items: center;
        background: ${color("common.white")};
        border: 1px solid ${color("common.ui7")};
        border-radius: 2px;
        height: 30px;
        padding: 1px;
    `,
};

jettingAppUnitsToggleStyles.button = {
    css: css`
        font-size: 14px;
        line-height: 22px;
        padding: 4px 10px;
        height: 26px;
        font-weight: bold;
        color: ${color("common.black")};
        opacity: 0.33;
        &.selected {
            background: ${color("primary.main")};
            opacity: 1;
            color: ${color("common.white")};
            border: 1px solid ${color("primary.main")};
            border-radius: 1px;
        }
    `,
};
